// Fields this page may send in the PUT, alongside the required key. The API
// also accepts arabicDescription / englishDescription, but the names are shown
// read-only here, so only the value is ever submitted.
export const EDITABLE_FIELDS = ["value"];

// The backend returns every login OTP setting under a single category, so the
// Dashboard / Taxpayer split is defined here by key. Keys are rendered in the
// order listed; anything the backend returns that is not listed below falls
// back to a section named after its own category.
export const SETTING_GROUPS = [
  {
    id: "dashboard",
    keys: [
      "login.otp.required.super_admin",
      "login.otp.required.dashboard.admin",
    ],
  },
  {
    id: "taxpayer",
    keys: ["login.otp.required.admin", "login.otp.required.sub_admin"],
  },
];
